import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative p-4"},[_c('h2',{staticClass:"text-lg text-grey-1"},[_vm._v(_vm._s(_vm.heading))]),_c('p',[_vm._v(_vm._s(_vm.body))]),_c(VBtn,{attrs:{"type":"primary"},on:{"click":_vm.clickHandler}},[_vm._v(_vm._s(_vm.buttonText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }